module.exports = __webpack_public_path__ + "static/business_model.27412aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/business_model.png
// module id = 654
// module chunks = 90675113806994